export const colTypeMinWidth : {[fieldDataTypeEnum: number]: number} = {
  0: 80,    // String
  1: 50,    // Int32
  2: 50,    // Int16
  3: 60,    // Double
  4: 60,    // Decimal
  5: 80,    // DateTime
  6: 38,    // Boolean
  7: 76,    // Image
  8:  80,    // Time
  100: 32   // DelayGroup
};

export const fieldDefaults: {[defaultName: string]: {defaultWidth: number, minWidth?: number}} = {
    "Number": { defaultWidth: 80, minWidth: undefined },
    "Number2": { defaultWidth: 100, minWidth: undefined },

    "Description1": { defaultWidth: 400, minWidth: undefined },
    "Description2": { defaultWidth: 400, minWidth: undefined },
    "Description3": { defaultWidth: 400, minWidth: undefined },
    "Description4": { defaultWidth: 400, minWidth: undefined },
    "Description5": { defaultWidth: 400, minWidth: undefined },
    "Description6": { defaultWidth: 400, minWidth: undefined },
    "Description7": { defaultWidth: 400, minWidth: undefined },
    "Description8": { defaultWidth: 400, minWidth: undefined },
    "Description9": { defaultWidth: 400, minWidth: undefined },
    "Date1": { defaultWidth: 104, minWidth: undefined },
    "Date2": { defaultWidth: 104, minWidth: undefined },
    "Date3": { defaultWidth: 104, minWidth: undefined },
    "Costs1": { defaultWidth: 125, minWidth: undefined },
    "Costs2": { defaultWidth: 125, minWidth: undefined },
    "Costs3": { defaultWidth: 125, minWidth: undefined },
    "Costs4": { defaultWidth: 125, minWidth: undefined },
    "Costs5": { defaultWidth: 125, minWidth: undefined },
    "CostsCategory": { defaultWidth: 200, minWidth: undefined },
    "Option1": { defaultWidth: 70, minWidth: 38 },
    "Option2": { defaultWidth: 70, minWidth: 38 },
    "Option3": { defaultWidth: 70, minWidth: 38 },
    "Option4": { defaultWidth: 70, minWidth: 38 },
    "Option5": { defaultWidth: 70, minWidth: 38 },
    "Option6": { defaultWidth: 70, minWidth: 38 },
    "Option7": { defaultWidth: 70, minWidth: 38 },
    "Option8": { defaultWidth: 70, minWidth: 38 },
    "Option9": { defaultWidth: 70, minWidth: 38 },

    "Classification1_Name1": { defaultWidth: 60, minWidth: undefined },
    "Classification1_Name2": { defaultWidth: 120, minWidth: undefined },
    "Classification2_Name1": { defaultWidth: 60, minWidth: undefined },
    "Classification2_Name2": { defaultWidth: 120, minWidth: undefined },
    "Classification3_Name1": { defaultWidth: 60, minWidth: undefined },
    "Classification3_Name2": { defaultWidth: 120, minWidth: undefined },
    "Classification4_Name1": { defaultWidth: 60, minWidth: undefined },
    "Classification4_Name2": { defaultWidth: 120, minWidth: undefined },
    "ProjectSpecific_Name1": { defaultWidth: 80, minWidth: undefined },
    "ProjectSpecific_Name2": { defaultWidth: 160, minWidth: undefined },
    "ProjectSpecific2_Name1": { defaultWidth: 80, minWidth: undefined },
    "ProjectSpecific2_Name2": { defaultWidth: 160, minWidth: undefined },


    "IsVisibleForCO": { defaultWidth: 70, minWidth: 38 },
    "IsVisibleForCT": { defaultWidth: 70, minWidth: 38 },

    "Company_Name1": { defaultWidth: 100, minWidth: undefined },
    "Company_Name2": { defaultWidth: 150, minWidth: undefined },
    "Company_Name3": { defaultWidth: 150, minWidth: undefined },
    "Company_SupplierNumber": { defaultWidth: 100, minWidth: undefined },
    "Company_Email": { defaultWidth: 130, minWidth: undefined },
    "Company_Phone": { defaultWidth: 100, minWidth: undefined },
    "Company_Fax": { defaultWidth: 100, minWidth: undefined },
    "Company_Internet": { defaultWidth: 130, minWidth: undefined },
    "Company_Street": { defaultWidth: 120, minWidth: undefined },
    "Company_ZipCode": { defaultWidth: 100, minWidth: undefined },
    "Company_City": { defaultWidth: 120, minWidth: undefined },
    "Company_ZipCode_PostBox": { defaultWidth: 100, minWidth: undefined },
    "Company_Postbox": { defaultWidth: 120, minWidth: undefined },
    "Company_Country": { defaultWidth: 120, minWidth: undefined },

    "Craft_Name1": { defaultWidth: 80, minWidth: undefined },
    "Craft_Name2": { defaultWidth: 160, minWidth: undefined },

    "Order_Name1": { defaultWidth: 80, minWidth: undefined },
    "Order_Name2": { defaultWidth: 160, minWidth: undefined },
    "Order_Date": { defaultWidth: 104, minWidth: undefined },
    "Order_EndOfWarrantyDate": { defaultWidth: 104, minWidth: undefined },
    "Order_AcceptanceDate": { defaultWidth: 104, minWidth: undefined },

    "Attribute_Name1": { defaultWidth: 100, minWidth: undefined },
    "Attribute_Name2": { defaultWidth: 120, minWidth: undefined },
    "AttributeGroup_Name1": { defaultWidth: 100, minWidth: undefined },
    "AttributeGroup_Image": { defaultWidth: 100, minWidth: 80 },

    "ResponsibleCO": { defaultWidth: 140, minWidth: undefined },
    "ResponsibleCO_Salutation": { defaultWidth: 70, minWidth: undefined },
    "ResponsibleCO_Email": { defaultWidth: 130, minWidth: undefined },
    "ResponsibleCO_Department": { defaultWidth: 120, minWidth: undefined },
    "ResponsibleCO_Fax": { defaultWidth: 100, minWidth: undefined },
    "ResponsibleCO_Company": { defaultWidth: 120, minWidth: undefined },
    "ResponsibleCO_Mobile": { defaultWidth: 100, minWidth: undefined },
    "ResponsibleCO_LastName": { defaultWidth: 120, minWidth: undefined },
    "ResponsibleCO_Phone": { defaultWidth: 100, minWidth: undefined },
    "ResponsibleCO_Title": { defaultWidth: 70, minWidth: undefined },
    "ResponsibleCO_FirstName": { defaultWidth: 120, minWidth: undefined },

    "ResponsibleCT": { defaultWidth: 140, minWidth: undefined },
    "ResponsibleCT_Salutation": { defaultWidth: 70, minWidth: undefined },
    "ResponsibleCT_Email": { defaultWidth: 130, minWidth: undefined },
    "ResponsibleCT_Department": { defaultWidth: 120, minWidth: undefined },
    "ResponsibleCT_Fax": { defaultWidth: 100, minWidth: undefined },
    "ResponsibleCT_Company": { defaultWidth: 120, minWidth: undefined },
    "ResponsibleCT_Mobile": { defaultWidth: 100, minWidth: undefined },
    "ResponsibleCT_LastName": { defaultWidth: 120, minWidth: undefined },
    "ResponsibleCT_Phone": { defaultWidth: 100, minWidth: undefined },
    "ResponsibleCT_Title": { defaultWidth: 70, minWidth: undefined },
    "ResponsibleCT_FirstName": { defaultWidth: 120, minWidth: undefined },

    "ResponsibleSC": { defaultWidth: 140, minWidth: undefined },
    "ResponsibleSC_Salutation": { defaultWidth: 70, minWidth: undefined },
    "ResponsibleSC_Email": { defaultWidth: 130, minWidth: undefined },
    "ResponsibleSC_Department": { defaultWidth: 120, minWidth: undefined },
    "ResponsibleSC_Fax": { defaultWidth: 120, minWidth: undefined },
    "ResponsibleSC_Company": { defaultWidth: 120, minWidth: undefined },
    "ResponsibleSC_Mobile": { defaultWidth: 120, minWidth: undefined },
    "ResponsibleSC_LastName": { defaultWidth: 120, minWidth: undefined },
    "ResponsibleSC_Phone": { defaultWidth: 120, minWidth: undefined },
    "ResponsibleSC_Title": { defaultWidth: 70, minWidth: undefined },
    "ResponsibleSC_FirstName": { defaultWidth: 120, minWidth: undefined },

    "CostsResponsible_Company": { defaultWidth: 200, minWidth: undefined },
    "CostsResponsible_Order": { defaultWidth: 180, minWidth: undefined },

    "Owner_Salutation": { defaultWidth: 100, minWidth: undefined },
    "Owner_DisplayName": { defaultWidth: 180, minWidth: undefined },
    "Owner_Fax": { defaultWidth: 120, minWidth: undefined },
    "Owner_Email": { defaultWidth: 150, minWidth: undefined },
    "Owner_Mobile": { defaultWidth: 120, minWidth: undefined },
    "Owner_FirstName": { defaultWidth: 120, minWidth: undefined },
    "Owner_Name1": { defaultWidth: 150, minWidth: undefined },
    "Owner_Name2": { defaultWidth: 150, minWidth: undefined },
    "Owner_City": { defaultWidth: 130, minWidth: undefined },
    "Owner_Street": { defaultWidth: 130, minWidth: undefined },
    "Owner_Phone": { defaultWidth: 120, minWidth: undefined },
    "Owner_Text1": { defaultWidth: 120, minWidth: undefined },
    "Owner_Text2": { defaultWidth: 120, minWidth: undefined },
    "Owner_Structure_Name1": { defaultWidth: 120, minWidth: undefined },
    "Owner_Structure_Name2": { defaultWidth: 180, minWidth: undefined },

    "Renter_Salutation": { defaultWidth: 100, minWidth: undefined },
    "Renter_DisplayName": { defaultWidth: 180, minWidth: undefined },
    "Renter_Fax": { defaultWidth: 120, minWidth: undefined },
    "Renter_Email": { defaultWidth: 150, minWidth: undefined },
    "Renter_Mobile": { defaultWidth: 120, minWidth: undefined },
    "Renter_FirstName": { defaultWidth: 120, minWidth: undefined },
    "Renter_Name1": { defaultWidth: 150, minWidth: undefined },
    "Renter_Name2": { defaultWidth: 150, minWidth: undefined },
    "Renter_City": { defaultWidth: 130, minWidth: undefined },
    "Renter_Street": { defaultWidth: 130, minWidth: undefined },
    "Renter_Phone": { defaultWidth: 120, minWidth: undefined },
    "Renter_Text1": { defaultWidth: 120, minWidth: undefined },
    "Renter_Text2": { defaultWidth: 120, minWidth: undefined },
    "Renter_Structure_Name1": { defaultWidth: 120, minWidth: undefined },
    "Renter_Structure_Name2": { defaultWidth: 180, minWidth: undefined },

    "PropertyManager_Salutation": { defaultWidth: 100, minWidth: undefined },
    "PropertyManager_DisplayName": { defaultWidth: 180, minWidth: undefined },
    "PropertyManager_Fax": { defaultWidth: 120, minWidth: undefined },
    "PropertyManager_Email": { defaultWidth: 150, minWidth: undefined },
    "PropertyManager_Mobile": { defaultWidth: 120, minWidth: undefined },
    "PropertyManager_FirstName": { defaultWidth: 120, minWidth: undefined },
    "PropertyManager_Name1": { defaultWidth: 150, minWidth: undefined },
    "PropertyManager_Name2": { defaultWidth: 150, minWidth: undefined },
    "PropertyManager_City": { defaultWidth: 130, minWidth: undefined },
    "PropertyManager_Street": { defaultWidth: 130, minWidth: undefined },
    "PropertyManager_Phone": { defaultWidth: 120, minWidth: undefined },
    "PropertyManager_Text1": { defaultWidth: 120, minWidth: undefined },
    "PropertyManager_Text2": { defaultWidth: 120, minWidth: undefined },
    "PropertyManager_Structure_Name1": { defaultWidth: 120, minWidth: undefined },
    "PropertyManager_Structure_Name2": { defaultWidth: 180, minWidth: undefined },

    "LastActivitySC_Status_Name1": { defaultWidth: 80, minWidth: undefined },
    "LastActivitySC_Status_Name2": { defaultWidth: 120, minWidth: undefined },
    "LastActivitySC_Description": { defaultWidth: 250, minWidth: undefined },
    "LastActivitySC_Date": { defaultWidth: 104, minWidth: undefined },
    "LastActivitySC_Deadline": { defaultWidth: 104, minWidth: undefined },
    "LastActivitySC_DeadlineReply": { defaultWidth: 104, minWidth: undefined },
    "LastActivitySC_Creator": { defaultWidth: 120, minWidth: undefined },
    "LastActivitySC_StatusGroupCT_obsolete": { defaultWidth: 110, minWidth: undefined },
    "LastActivitySC_StatusGroupSC": { defaultWidth: 110, minWidth: undefined },

    "LastActivityCT_Status_Name1": { defaultWidth: 80, minWidth: undefined },
    "LastActivityCT_Status_Name2": { defaultWidth: 120, minWidth: undefined },
    "LastActivityCT_Description": { defaultWidth: 250, minWidth: undefined },
    "LastActivityCT_Date": { defaultWidth: 104, minWidth: undefined },
    "LastActivityCT_Deadline": { defaultWidth: 104, minWidth: undefined },
    "LastActivityCT_DeadlineReply": { defaultWidth: 104, minWidth: undefined },
    "LastActivityCT_Creator": { defaultWidth: 120, minWidth: undefined },
    "LastActivityCT_StatusGroupSC_obsolete": { defaultWidth: 110, minWidth: undefined },
    "LastActivityCT_StatusGroupCT": { defaultWidth: 110, minWidth: undefined },

    "LastActivityCO_StatusGroupCT": { defaultWidth: 110, minWidth: undefined },
    "LastActivityCO_StatusGroupSC": { defaultWidth: 110, minWidth: undefined },

    "CreatedOn": { defaultWidth: 104, minWidth: undefined },
    "CreatedOn_Date": { defaultWidth: 104, minWidth: undefined },
    "CreatedOn_Time": { defaultWidth: 104, minWidth: undefined },
    "CreatedOnMobile": { defaultWidth: 104, minWidth: undefined },
    "CreatedOnMobile_Time": { defaultWidth: 104, minWidth: undefined },
    "Creator": { defaultWidth: 120, minWidth: undefined },

    "ModifiedOn": { defaultWidth: 104, minWidth: undefined },
    "ModifiedOn_Date": { defaultWidth: 104, minWidth: undefined },
    "ModifiedOn_Time": { defaultWidth: 104, minWidth: undefined },
    "ModifiedOnMobile": { defaultWidth: 104, minWidth: undefined },
    "ModifiedOnMobile_Time": { defaultWidth: 104, minWidth: undefined },
    "Modifier": { defaultWidth: 120, minWidth: undefined },

    "DelaySC": { defaultWidth: 70, minWidth: undefined },
    "DelayGroupSC_Id": { defaultWidth: 70, minWidth: 38 },
    "DelayGroupSC_Text": { defaultWidth: 110, minWidth: undefined },
    "DelayCT": { defaultWidth: 70, minWidth: undefined },
    "DelayGroupCT_Id": { defaultWidth: 70, minWidth: 38 },
    "DelayGroupCT_Text": { defaultWidth: 110, minWidth: undefined },

    "FirstImage": { defaultWidth: 80, minWidth: 80 },
    "LastImage": { defaultWidth: 80, minWidth: 80 },
    "FirstPlanSection": { defaultWidth: 80, minWidth: 80 },
    "LastPlanSection": { defaultWidth: 80, minWidth: 80 },

    "HasNotSentEmails": { defaultWidth: 70, minWidth: 38 },

    "Structure_Name1": { defaultWidth: 120, minWidth: undefined },
    "Structure_Name2": { defaultWidth: 180, minWidth: undefined },
    "Structure_Level1_Name1": { defaultWidth: 120, minWidth: undefined },
    "Structure_Level2_Name1": { defaultWidth: 120, minWidth: undefined },
    "Structure_Level3_Name1": { defaultWidth: 120, minWidth: undefined },
    "Structure_Level4_Name1": { defaultWidth: 120, minWidth: undefined },
    "Structure_Level5_Name1": { defaultWidth: 120, minWidth: undefined },
    "Structure_Level6_Name1": { defaultWidth: 120, minWidth: undefined },
    "Structure_Level7_Name1": { defaultWidth: 120, minWidth: undefined },
    "Structure_Level8_Name1": { defaultWidth: 120, minWidth: undefined },
    "Structure_Level9_Name1": { defaultWidth: 120, minWidth: undefined },
    "Structure_Level10_Name1": { defaultWidth: 120, minWidth: undefined },
    "Structure_Level1_Name2": { defaultWidth: 180, minWidth: undefined },
    "Structure_Level2_Name2": { defaultWidth: 180, minWidth: undefined },
    "Structure_Level3_Name2": { defaultWidth: 180, minWidth: undefined },
    "Structure_Level4_Name2": { defaultWidth: 180, minWidth: undefined },
    "Structure_Level5_Name2": { defaultWidth: 180, minWidth: undefined },
    "Structure_Level6_Name2": { defaultWidth: 180, minWidth: undefined },
    "Structure_Level7_Name2": { defaultWidth: 180, minWidth: undefined },
    "Structure_Level8_Name2": { defaultWidth: 180, minWidth: undefined },
    "Structure_Level9_Name2": { defaultWidth: 180, minWidth: undefined },
    "Structure_Level10_Name2": { defaultWidth: 180, minWidth: undefined },
    "Structure_ShortPath": { defaultWidth: 180, minWidth: undefined },
    "Structure_LongPath": { defaultWidth: 180, minWidth: undefined },
    "Structure_DisplayPath": { defaultWidth: 180, minWidth: undefined },

    "StructureCategory_Name1": { defaultWidth: 110, minWidth: undefined },
    "StructureCategory_Name2": { defaultWidth: 170, minWidth: undefined },

    "StructureSortId": { defaultWidth: 100, minWidth: undefined },
    "Unique_Id": { defaultWidth: 100, minWidth: undefined },

    "IsSubDefect": { defaultWidth: 70, minWidth: 38 },

    "DefectAttachments_Count": { defaultWidth: 70, minWidth: 38 },
    "DefectAudioFiles_Count": { defaultWidth: 70, minWidth: 38 },
    "DefectPictures_Count": { defaultWidth: 70, minWidth: 38 },
    "DefectPlanSections_Count": { defaultWidth: 70, minWidth: 38 },
    "SubDefects_Count": { defaultWidth: 70, minWidth: 38 },

    "StatusField_{{statusId}}_Description": { defaultWidth: 180, minWidth: undefined },
    "StatusField_{{statusId}}_Date": { defaultWidth: 104, minWidth: undefined },
    "StatusField_{{statusId}}_Deadline": { defaultWidth: 104, minWidth: undefined },
    "StatusField_{{statusId}}_DeadlineReply": { defaultWidth: 104, minWidth: undefined },
    "StatusField_{{statusId}}_Creator": { defaultWidth: 120, minWidth: undefined },
    "StatusField_{{statusId}}_ShareLog": { defaultWidth: 180, minWidth: undefined },
  };
